module.exports = __webpack_public_path__ + "static/media/csa_logo.351b0a36.jpg";